import { Paper, Stack } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import ResourceCard from '@/features/resource/components/ResourceCard'
import { SoCLiveReadout } from '@/features/resource/components/socManagement/SoCLiveReadout'
import { TargetSoCForm } from '@/features/resource/components/socManagement/TargetSoCForm'
import { isSoCManagementTabVisible } from '@/features/resource/configuration/utils/socManagementVisibility'
import { ResourceRouteInformation } from '@/features/resource/constants'
import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import { useResourceDetails } from '@/features/resource/pages/ResourceDetailsPage'

function SoCManagementPage() {
  const { t } = useTranslation()
  const { resourceUuid } = useParams()
  const { setActivePage } = useResourceDetails()
  const { resource } = useResourceData()
  const { permissions } = usePermissions()

  useEffect(() => {
    setActivePage(ResourceRouteInformation.RESOURCE_SOC_MANAGEMENT.routePath)
  }, [setActivePage])

  const isVisible = isSoCManagementTabVisible({
    resource,
    hasTargetSocPermission: permissions.has('targetSocMutation'),
  })

  if (!resourceUuid) {
    return null
  }

  const batteryControlPortId =
    resource?.controlPorts.find((port) => port.controlBoxType === 'BATTERY')?.controlPortID ?? null

  const content = !isVisible ? (
    <Paper sx={{ p: 3 }}>{t('resources.soc_management.not_available')}</Paper>
  ) : (
    <Stack alignItems="flex-start" direction={{ xs: 'column', md: 'row' }} spacing={3}>
      <Paper sx={{ p: 3, flex: 6, width: '100%', maxWidth: { md: 640 }, minWidth: 0 }}>
        <TargetSoCForm resourceId={resourceUuid} />
      </Paper>
      <Stack sx={{ flex: 4, width: { xs: '100%', md: 'auto' } }}>
        <SoCLiveReadout controlPortId={batteryControlPortId} estimatedPower={resource?.estimatedPower ?? null} />
      </Stack>
    </Stack>
  )

  return <ResourceCard content={content} showGeneralInfo={false} />
}

export default SoCManagementPage
